import{catalogSearchFilterLabel}from'./catalog-search-copy';
/** Customer copy only; all current business facts remain original source projections. */
const en = {
  "B01": "Good things, chosen slowly.",
  "B02": "Search results",
  "B03": "About this piece",
  "B04": "From this shop",
  "B05": "Your collections",
  "B06": "Gift registry",
  "missing": "These details aren’t available yet. Refresh the page or try another listing.",
  "empty": "No finds just yet.",
  "emptyCollection": "This collection is waiting for its first find.",
  "gallery": "Listing gallery",
  "previous": "Previous image",
  "nextImage": "Next image",
  "policies": "Shop policies",
  "disclosures": "How it’s made",
  "orders": "Your orders",
  "filters": "Selected filters",
  "clear": "Remove",
  "next": "See more",
  "pending": "We haven’t confirmed this request yet. Check its status before trying again.",
  "stale": "Some details changed. Refresh, then review them before continuing.",
  "private": "Private",
  "shared": "Shared",
  "policy": "Registry policy",
  "scope": "Access",
  "owner": "Your registry",
  "recipient": "Invited recipient",
  "choices": "Choose your options and review the details before continuing.",
  "options": "Options and purchase",
  "shopTerms": "Review delivery and return terms on each listing.",
  "emptyShop": "This shop has no listings to show right now.",
  "emptyHelp": "Try a different search or remove a filter to explore more work.",
  "browseHint": "Explore the details, compare options and find what feels like you."
};
type Copy = {[K in keyof typeof en]:string};
const es:Copy = {
  "B01": "Cosas buenas, elegidas con calma.",
  "B02": "Resultados de búsqueda",
  "B03": "Sobre esta pieza",
  "B04": "De esta tienda",
  "B05": "Tus colecciones",
  "B06": "Lista de regalos",
  "missing": "Los detalles no están disponibles. Actualiza la página o consulta otro artículo.",
  "empty": "Todavía no hay resultados.",
  "emptyCollection": "Esta colección espera su primer hallazgo.",
  "gallery": "Galería del artículo",
  "previous": "Imagen anterior",
  "nextImage": "Imagen siguiente",
  "policies": "Políticas de la tienda",
  "disclosures": "Cómo se hace",
  "orders": "Tus pedidos",
  "filters": "Filtros elegidos",
  "clear": "Quitar",
  "next": "Ver más",
  "pending": "Aún no hemos confirmado esta solicitud. Consulta su estado antes de repetirla.",
  "stale": "Algunos detalles han cambiado. Actualiza y revísalos antes de continuar.",
  "private": "Privada",
  "shared": "Compartida",
  "policy": "Política de la lista",
  "scope": "Acceso",
  "owner": "Tu lista",
  "recipient": "Destinatario invitado",
  "choices": "Elige las opciones y revisa los detalles antes de continuar.",
  "options": "Opciones y compra",
  "shopTerms": "Consulta las condiciones de envío y devolución de cada artículo.",
  "emptyShop": "Esta tienda no tiene artículos para mostrar ahora.",
  "emptyHelp": "Prueba otra búsqueda o quita un filtro para descubrir más.",
  "browseHint": "Explora los detalles y compara las opciones para encontrar tu favorito."
};
const fr:Copy = {
  "B01": "De belles choses, choisies avec soin.",
  "B02": "Résultats de recherche",
  "B03": "À propos de cette pièce",
  "B04": "Dans cette boutique",
  "B05": "Vos collections",
  "B06": "Liste de cadeaux",
  "missing": "Ces détails ne sont pas disponibles. Actualisez la page ou consultez un autre article.",
  "empty": "Aucun résultat pour le moment.",
  "emptyCollection": "Cette collection attend sa première trouvaille.",
  "gallery": "Galerie de l’article",
  "previous": "Image précédente",
  "nextImage": "Image suivante",
  "policies": "Politiques de la boutique",
  "disclosures": "Comment cette pièce est créée",
  "orders": "Vos commandes",
  "filters": "Filtres sélectionnés",
  "clear": "Retirer",
  "next": "Voir plus",
  "pending": "Cette demande n’est pas encore confirmée. Consultez son état avant de réessayer.",
  "stale": "Certains détails ont changé. Actualisez et vérifiez-les avant de continuer.",
  "private": "Privée",
  "shared": "Partagée",
  "policy": "Politique de la liste",
  "scope": "Accès",
  "owner": "Votre liste",
  "recipient": "Destinataire invité",
  "choices": "Choisissez vos options et vérifiez les détails avant de continuer.",
  "options": "Options et achat",
  "shopTerms": "Consultez les conditions de livraison et de retour de chaque article.",
  "emptyShop": "Cette boutique n’a aucun article à afficher pour le moment.",
  "emptyHelp": "Essayez une autre recherche ou retirez un filtre.",
  "browseHint": "Explorez les détails et comparez les options pour trouver votre coup de cœur."
};
const de:Copy = {
  "B01": "Besondere Dinge, mit Ruhe ausgewählt.",
  "B02": "Suchergebnisse",
  "B03": "Über dieses Stück",
  "B04": "Aus diesem Shop",
  "B05": "Deine Sammlungen",
  "B06": "Geschenkliste",
  "missing": "Die Details sind noch nicht verfügbar. Lade die Seite neu oder wähle einen anderen Artikel.",
  "empty": "Noch keine Fundstücke.",
  "emptyCollection": "Diese Sammlung wartet auf ihr erstes Fundstück.",
  "gallery": "Bildergalerie",
  "previous": "Vorheriges Bild",
  "nextImage": "Nächstes Bild",
  "policies": "Shopregeln",
  "disclosures": "So entsteht dieses Stück",
  "orders": "Deine Bestellungen",
  "filters": "Gewählte Filter",
  "clear": "Entfernen",
  "next": "Mehr entdecken",
  "pending": "Diese Anfrage ist noch nicht bestätigt. Prüfe ihren Status vor einem neuen Versuch.",
  "stale": "Einige Details haben sich geändert. Lade die Seite neu und prüfe sie vor dem Fortfahren.",
  "private": "Privat",
  "shared": "Geteilt",
  "policy": "Regeln der Geschenkliste",
  "scope": "Zugriff",
  "owner": "Deine Geschenkliste",
  "recipient": "Eingeladener Empfänger",
  "choices": "Wähle deine Optionen und prüfe die Details, bevor du fortfährst.",
  "options": "Optionen und Kauf",
  "shopTerms": "Prüfe Versand und Rückgabe bei jedem Angebot.",
  "emptyShop": "Dieser Shop zeigt zurzeit keine Angebote.",
  "emptyHelp": "Versuche eine andere Suche oder entferne einen Filter.",
  "browseHint": "Entdecke die Details und vergleiche, was zu dir passt."
};
const ja:Copy = {
  "B01": "ゆっくり選ぶ、心に残るもの。",
  "B02": "検索結果",
  "B03": "この作品について",
  "B04": "このショップの作品",
  "B05": "コレクション",
  "B06": "ギフトリスト",
  "missing": "詳細を表示できません。ページを更新するか、別の商品をご覧ください。",
  "empty": "まだ商品が見つかりません。",
  "emptyCollection": "最初のお気に入りを保存してみましょう。",
  "gallery": "商品の写真",
  "previous": "前の写真",
  "nextImage": "次の写真",
  "policies": "ショップのポリシー",
  "disclosures": "作品のつくり方",
  "orders": "注文履歴",
  "filters": "選択した条件",
  "clear": "解除",
  "next": "もっと見る",
  "pending": "まだこのリクエストの結果を確認できていません。再試行する前に状況をご確認ください。",
  "stale": "詳細が変更されています。ページを更新し、内容を確認してから次へ進んでください。",
  "private": "非公開",
  "shared": "共有",
  "policy": "ギフトリストの方針",
  "scope": "アクセス",
  "owner": "自分のギフトリスト",
  "recipient": "招待された受取人",
  "choices": "オプションを選び、詳細を確認してから次へ進んでください。",
  "options": "オプションと購入",
  "shopTerms": "各商品の配送・返品条件をご確認ください。",
  "emptyShop": "現在、このショップに表示できる商品はありません。",
  "emptyHelp": "検索内容を変えるか、条件を外してみてください。",
  "browseHint": "詳細を見て比べながら、お気に入りを見つけましょう。"
};
export const discoveryCopy=(locale:string):Copy=>({en,de,fr,es,ja}[locale as "en"]||en);
const labels={"en": {"q": "Search", "destination": "Destination", "kind": "Item type", "sort": "Sort"}, "de": {"q": "Suche", "destination": "Ziel", "kind": "Artikelart", "sort": "Sortierung"}, "fr": {"q": "Recherche", "destination": "Destination", "kind": "Type d’article", "sort": "Tri"}, "es": {"q": "Búsqueda", "destination": "Destino", "kind": "Tipo de artículo", "sort": "Orden"}, "ja": {"q": "検索", "destination": "配送先", "kind": "商品種別", "sort": "並び順"}};
export const discoveryFilterLabel=(locale:string,key:string)=>{const current=labels[locale as "en"]||labels.en;return current[key as keyof typeof current]||catalogSearchFilterLabel(locale,key)||""};
